export default {
  NOTES_DETAILS_LIST_REQUEST: 'APP/NOTES_DETAILS/NOTES_DETAILS_LIST_REQUEST',
  NOTES_DETAILS_LIST_SUCCESS: 'APP/NOTES_DETAILS/NOTES_DETAILS_LIST_SUCCESS',
  NOTES_DETAILS_LIST_ERROR: 'APP/NOTES_DETAILS/NOTES_DETAILS_LIST_ERROR',
};
